import { SET_GLOBAL_INITIALIZE } from '@naruto/naruto-reducers/src/reducers/global/actions';
import { SET_MESSAGE_INITIALIZE } from '@naruto/naruto-reducers/src/reducers/message/actions';
import { SET_USER_INITIALIZE_APPLICATION } from '@naruto/bgdapp/src/reducers/cores/user/actions';
import { ThunkAction, Models, MiddleWare } from './types';

export const resetAllReduxStoreState =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch): Promise<void> => {
    dispatch(SET_GLOBAL_INITIALIZE());
    dispatch(SET_MESSAGE_INITIALIZE());
    dispatch(SET_USER_INITIALIZE_APPLICATION());
  };
